import React, {useEffect} from 'react';
import {useNavigate} from 'react-router';
import {logoutApi} from '../services/authService';
import { consoleToLog, getServiceName } from '../util/AppUtil';

const LogoutPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        let service_name = getServiceName(window.location.href);
        navigate(`/login?service=${service_name}`);

    }, [])

    return (
        <div>

        </div>
    );
}

export default LogoutPage;